<template>
  <ion-row>
    <ion-col :style="{textAlign: 'center', color: computedColorText}">
      <h4>
        {{ computedMessage }}
      </h4>
    </ion-col>
  </ion-row>
  <ion-row class="row-progress">
    <ion-col class="bar-progress" size="1"></ion-col>
    <ion-col class="bar-progress" size="2">
      <ion-icon color="danger" :icon="caretDownOutline" 
        :style="{paddingLeft: `${(computedDanger/1)*4.5}em`, opacity: computedOrange > 0 ? 0 :1}">
      </ion-icon>
      <ion-progress-bar class="bar-progress-begin" color="danger" :value="computedDanger"></ion-progress-bar>
    </ion-col>
    <ion-col class="bar-progress" size="2">
      <ion-icon class="icon-progress-orange" :icon="caretDownOutline" 
        :style="{paddingLeft: `${(computedOrange/1)*4.5}em`, opacity: (computedPercent > 20 && computedPercent <= 40 ? 1 : 0)}">
      </ion-icon>
      <ion-progress-bar class="bar-progress-orange" :value="computedOrange"></ion-progress-bar>
    </ion-col>
    <ion-col class="bar-progress" size="2">
      <ion-icon color="warning" :icon="caretDownOutline" 
        :style="{paddingLeft: `${(computedWarning/1)*4.5}em`, opacity: (computedPercent > 40 && computedPercent <= 60 ? 1 : 0)}">
      </ion-icon>
      <ion-progress-bar color="warning" :value="computedWarning"></ion-progress-bar>
    </ion-col>
    <ion-col class="bar-progress" size="2">
      <ion-icon color="success" :icon="caretDownOutline" 
        :style="{paddingLeft: `${(computedSuccess/1)*4.5}em`, opacity: (computedPercent > 60 && computedPercent <= 80 ? 1 : 0)}">
      </ion-icon>
      <ion-progress-bar color="success" :value="computedSuccess"></ion-progress-bar>
    </ion-col>
    <ion-col class="bar-progress" size="2">
      <ion-icon color="primary" :icon="caretDownOutline" 
        :style="{paddingLeft: `${(computedInfo/1)*4.5}em`, opacity: computedInfo > 0 ? 1 : 0}">
      </ion-icon>
      <ion-progress-bar class="bar-progress-end" :value="computedInfo" ></ion-progress-bar>
    </ion-col>
    <ion-col class="bar-progress" size="1"></ion-col>
  </ion-row>
  <ion-row>
    <ion-col :style="{textAlign: 'center', color: computedColorText}">
      <b :style="{}">
        {{computedPercent.toFixed(0,2) || 0}}%
      </b>
    </ion-col>
  </ion-row>
</template>

<script>
  import {
    IonProgressBar,
    IonRow,
    IonIcon,
    IonCol
  } from '@ionic/vue'

  import {
    caretDownOutline
  } from "ionicons/icons";

  export default {
    name: "BulletBar",
    components: {
      IonProgressBar,
      IonIcon,
      IonRow,
      IonCol
    },
    props:{
      value: {
        type: Number,
        required: true
      },
      valueTotal: {
        type: Number,
        required: true
      }
    },
    data() {
      
    },
    computed: {
      computedPercent() {
        return this.value ? (((this.value * 1)/(this.valueTotal * 1)) * 100) : 0
      },
      computedColorText() {
        if (this.computedPercent > 80) {
          return '#3880ff'
        } else if (this.computedPercent > 60) {
          return '#2dd36f'
        } else if (this.computedPercent > 40) {
          return '#ffc409'
        } else if (this.computedPercent > 20) {
          return 'rgba(235, 153, 1, 1)'
        } else {
          return '#eb445a'
        }
      },
      computedMessage() {
        if (this.computedPercent > 80) {
          return 'Perfeito'
        } else if (this.computedPercent > 60) {
          return 'Regular'
        } else if (this.computedPercent > 40) {
          return 'Médio'
        } else if (this.computedPercent > 20) {
          return 'Fraco'
        } else {
          return 'Baixo'
        }
      },
      computedDanger() {
        return this.computedPercent > 20 ? 1 : (this.computedPercent/20)
      },
      computedOrange() {
        return this.computedPercent > 40 ? 1 : this.computedPercent > 20 ? ((this.computedPercent-20)/20) : 0
      },
      computedWarning() {
        return this.computedPercent > 60 ? 1 : this.computedPercent > 40 ? ((this.computedPercent-40)/20) : 0
      },
      computedSuccess() {
        return this.computedPercent > 80 ? 1 : this.computedPercent > 60 ? ((this.computedPercent-60)/20) : 0
      },
      computedInfo() {
        return this.computedPercent >= 100 ? 1 : this.computedPercent > 80 ? ((this.computedPercent-80)/20) : 0
      }
    },
    setup() {
      return {
        caretDownOutline
      }
    }
  }
</script>

<style>
  .row-progress{
    margin-left: -2.25em;
    margin-right: -2.25em;
  }

  .bar-progress-orange {
    --background: rgba(235, 153, 1, 0.541);
    --progress-background: rgba(235, 153, 1, 1)  
  }

  .icon-progress-orange {
    color: rgba(235, 153, 1, 1)  
  }

  .bar-progress {
    padding: 0;
    margin: 0;
  }

  .bar-progress-begin {
    border-radius: 25px 0 0 25px
  }

  .bar-progress-end {
    border-radius: 0 25px 25px 0
  }

  ion-progress-bar {
    height: 12px;
  }
</style>